import { Box, styled, Tooltip, Typography } from "@mui/material";

const Container = styled(Box)({
  width: "100%",
  color: "#CFEDEC",
  height: "100%",
});

const BarWrapper = styled(Box)({
  width: "100%",
  height: "26px",
  backgroundColor: "#000",
  borderRadius: "4px",
  position: "relative",
  overflow: "visible",
});

const Segment = styled(Box)(({ color, width }) => ({
  height: "100%",
  width: width,
  backgroundColor: color,
  position: "absolute",
  left: 0,
  top: 0,
}));

// ใช้รูปแทน flag
const FlagIcon = styled("img")(({ left }) => ({
  position: "absolute",
  top: "-23px",
  left: left,
  width: "55px",
}));

export default function ProgressFG({
  actual = 0,
  previousTarget = 0,
  target = 0,

  // ⭐ NEW: ให้กำหนดค่า position ของธงได้
  flagPositionValue = previousTarget, // ถ้าไม่ใส่จะใช้ previousTarget เหมือนเดิม

  flagSrc = `${process.env.PUBLIC_URL}/images/icons/Target.png`,
}) {
  // percent ของแต่ละ segment
  const pctActual = (actual / target) * 100;
  const pctPrev = (previousTarget / target) * 100;

  // ⭐ percent ของธง
  const pctFlag = (flagPositionValue / target) * 100;

  return (
    <Container>
      {/* Header */}
      <Box display="flex" justifyContent="space-between" mb={0.5}>
        <Box>
          <Typography fontSize={"clamp(20px,4vw,28px)"}>Actual (FG)</Typography>
          <Typography
            fontSize={"clamp(22px,4vw,30px)"}
            fontWeight={700}
            color="#7FE0D4"
          >
            {actual.toLocaleString()} <span style={{ fontSize: 20 }}>kg</span>
          </Typography>
        </Box>

        <Box textAlign="right">
          <Typography fontSize={"clamp(20px,4vw,28px)"}>Target (FG)</Typography>
          <Typography
            fontSize={"clamp(22px,4vw,30px)"}
            fontWeight={700}
            color="#7FE0D4"
          >
            {target.toLocaleString()} <span style={{ fontSize: 20 }}>kg</span>
          </Typography>
        </Box>
      </Box>

      {/* Progress Bar */}
      <BarWrapper>
        <Segment color="#2EA69A" width={`${pctActual}%`} />

        <Segment
          color="#AEE8DB"
          width={`${pctPrev - pctActual}%`}
          sx={{ left: `${pctActual}%` }}
        />

        {/* <Segment
          color="#000"
          width={`${100 - pctPrev}%`}
          sx={{ left: `${pctPrev}%` }}
        /> */}

        {/* FLAG ICON — now based on custom flagPositionValue */}
        {/* <Typography
          fontSize={20}
          fontWeight={400}
          sx={{
            position: "relative",
            bottom: 54,
            left: `calc(${pctFlag}%)`,
          }}
          color="#fff"
        >
          {flagPositionValue.toLocaleString()}
        </Typography> */}
        <Tooltip componentsProps={{
          tooltip: {
            sx: {
              bgcolor: "#000",
              color: "#fff",
              fontSize: 16,
              borderRadius: "6px",
            },
          },
        }} title={flagPositionValue.toLocaleString()} placement="top-end">
          <FlagIcon src={flagSrc} left={`calc(${pctFlag}% - 17px)`} />
        </Tooltip>
      </BarWrapper>

      <Box
        mt={0.6}
        display="flex"
        justifyContent={pctPrev < 90 ? "left" : "right"}
      >
        <Typography
          fontSize={"clamp(20px,4vw,28px)"}
          color="#7FE0D4"
          sx={pctPrev < 90 && { paddingLeft: `calc(${pctPrev}%)` }}
        >
          {previousTarget.toLocaleString()}
        </Typography>
      </Box>
    </Container>
  );
}
